import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Form, Button, Alert } from 'react-bootstrap';
import { Input, Checkbox } from '../common/components/formControls';
import validators from '../common/services/validators';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

const passwordMinLength = validators.minLength(6);

const ImpersonationForm = ({ error, handleSubmit, pristine, submitting, t }) => {

	return (
		<Form onSubmit={handleSubmit} className='form-login'>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Field name='username' component={Input} type='text' disabled placeholder={t('FO_Login_Email')} icon='fa fa-user' validate={validators.required} className='form-control redux-field' />
			<Field name='password' component={Input} type='password' placeholder={t('FO_Login_Password')} icon='fa fa-lock' validate={[validators.required, passwordMinLength]} />
			<div className='form-actions'>
				<Button type='submit' disabled={pristine || submitting} className='btn btn-primary btn-auth'>
					{t('FO_Login_Login')} <i className='fa fa-arrow-circle-right' />
				</Button>
			</div>
		</Form>
	);
};

export default reduxForm({ form: 'impersonation' })(withTranslation()(ImpersonationForm));